import React from "react";
import { useWidgetConfiguration } from "./configuration";
export function useWidgetBusData(topicName) {
    const widgetConfiguration = useWidgetConfiguration();
    const [currentValue, setCurrentValue] = React.useState(() => widgetConfiguration.bus.dangerouslyGetCurrentValue(topicName));
    const subscribeCb = React.useCallback((value) => {
        setCurrentValue(value);
    }, []);
    React.useEffect(() => {
        const handle = widgetConfiguration.bus.subscribe(topicName, subscribeCb);
        return () => {
            widgetConfiguration.bus.unsubscribe(handle);
        };
    }, [subscribeCb, topicName, widgetConfiguration]);
    return currentValue;
}
